export const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      // weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    }
  },
  'nl-NL': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      // weekday: 'short',
      hour: 'numeric',
      second: 'numeric',
      minute: 'numeric'
    }
  },
  'de-DE': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      // weekday: 'short',
      hour: 'numeric',
      second: 'numeric',
      minute: 'numeric'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/dateTimeFormats.js